import { ReactNode } from 'react';

import { CalendarIcon } from '@/lib/shared/icons';
import {
  Bedcloths,
  BedroomSVG,
  Butler,
  Cleaning,
  Cook,
  Electricity,
  Guard,
  Maiden,
  Manager,
  Technician,
  Water,
} from '@/lib/shared/icons/rent';
import {
  Gym,
  KidsRoom,
  Parking,
  PetsAllowed,
  Pool,
  Restaurant,
  Shuttle,
  Spa,
  Wifi,
} from '@/lib/shared/icons/rent/features';

const SERVICE_ICONS: Record<string, ReactNode> = {
  wifi: <Wifi />,
  pool: <Pool />,
  parking: <Parking />,
  cleaning: <Cleaning />,
  gym: <Gym />,
  spa: <Spa />,
  kidsClub: <KidsRoom />,
  concierge: <Manager />,
  manager: <Manager />,
  transfer: <Shuttle />,
  airportTransfer: <Shuttle />,
  earlyCheckIn: <CalendarIcon />,
  lateCheckOut: <CalendarIcon />,
  extraBed: <BedroomSVG />,
  breakfast: <Restaurant />,
  petFee: <PetsAllowed />,
  water: <Water />,
  electricity: <Electricity />,
  bedclothesChange: <Bedcloths />,
  butler: <Butler />,
  technician: <Technician />,
  guard: <Guard />,
  cook: <Cook />,
  maiden: <Maiden />,
};

export const INCLUDED_SERVICE_ICONS = SERVICE_ICONS;
export const PAID_SERVICE_ICONS = SERVICE_ICONS;
